<template>
  <el-dialog
    v-drag
    v-loading="loading"
    :visible.sync="dialogVisible"
    width="1080px"
    :show-close="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="beforeClose"
    :title="diaLogType ? '提单文件' : '上传附件'"
  >
    <div slot="title" class="el-dialog__title">
      {{ diaLogType ? "提单文件" : "上传附件" }}
      <span v-if="rowData.isPushGGT" class="ggt">已推送GGT</span>
    </div>
    <div class="view">
      <div class="opt">
        <span class="label">上传类型</span>
        <el-cascader
          v-model="type"
          :options="fileOptions"
          style="margin-right: 15px; width: 200px"
          size="mini"
          placeholder="选择上传类型"
        >
        </el-cascader>
        <span class="label">备注</span>
        <el-input
          v-model="remark"
          style="width: 500px"
          type="textarea"
          :rows="1"
          placeholder="请输入备注(非必填)"
        ></el-input>
        <el-upload
          action="#"
          :show-file-list="false"
          :http-request="httpRequest"
        >
          <div class="upload">
            <img src="@/assets/images/bill/upload-1.png" alt="" />
            选择文件上传
          </div>
        </el-upload>
      </div>
      <div class="data">
        <div v-for="group in tableData.columns" :key="group.uploadType" class="file-group">
          <div class="file-group-title">{{ group.groupName }}</div>
          <table v-if="group.files?.length" class="file-list">
            <tr v-for="file in group.files" :key="file.id" class="file-item">
              <td class="file-name-box">
                <div class="file-item-icon"><img :src="file.icon" /></div>
                <div class="file-item-name" :title="file.fileName">{{ file.fileName }}</div>
                <div class="common-label-success">{{ file.typeName }}</div>
              </td>
              <td class="file-item-time">{{ file.createdName }} 于{{ file.createdOn }}上传</td>
              <td class="file-item-remark" :title="file.remark">{{ file.remark }}</td>
              <td class="file-item-opt">
                <div class="flex-center" style="gap: 10px; cursor: pointer">
                  <img src="@/assets/images/bill/download.png" alt="下载" @click="download(file)" />
                  <i class="el-icon-zoom-in" style="color: rgb(18, 88, 188);" alt="查看" @click="check(file)"></i>
                  <div
                    v-if="file.allowDel"
                    title="删除"
                    class="btn"
                    @click="deleteFile(file)"
                  >
                    <i class="el-icon-delete"></i>
                  </div>
                  <!-- <img src="@/assets/images/bill/search.png" alt="查看" @click="handleView(file)" /> -->
                </div>
              </td>
            </tr>
          </table>
          <div v-else class="file-list flex-center">--</div>
        </div>
        <!-- <BaseTable
          :height="diaLogType ? 407 : 500"
          :tableData="tableData"
          :isPager="false"
          :border="true"
        >
          <template slot="typeName" slot-scope="row">
            <div style="display: flex">
              {{ row.scope.typeName }}
              <el-popover
                v-if="row.scope.type === 16"
                placement="bottom"
                width="278"
                trigger="hover"
              >
                <div slot="reference" class="btn">
                  <img
                    style="margin-top: 4px"
                    src="@/assets/images/bill/detail-msg.png"
                  />
                </div>
                <div class="onwer-content">
                  <p>
                    <span class="label">卡车</span>
                    <span class="value">{{ row.scope.truckCompany }}</span>
                  </p>
                  <p>
                    <span class="label">自提单号</span>
                    <span class="value">{{ row.scope.selfPickupNumber }}</span>
                  </p>
                  <p>
                    <span class="label">提货时间</span>
                    <span class="value">{{
                      row.scope.deliveryTime?.split(" ")[0]
                    }}</span>
                  </p>
                </div>
              </el-popover>
            </div>
          </template>
          <template slot="fileName" slot-scope="row">
            <p style="text-align: left; white-space: initial">
              {{ row.scope.fileName }}
            </p>
            <p style="text-align: left">
              <template
                v-if="row.scope.tagsJson && row.scope.tagsJson.length > 0"
              >
                <span
                  v-for="(item, $index) in row.scope.tagsJson"
                  :key="$index"
                  class="tag"
                  :style="{
                    color: item.colorArgb,
                    'background-color': item.bgColor,
                  }"
                >
                  {{ item.label }}
                </span>
              </template>
            </p>
          </template>
          <template slot="remark" slot-scope="row">
            <el-popover placement="bottom-end" width="440" trigger="hover">
              <div class="remarks-box">
                <div class="remarks-header">
                  <span>备注内容</span>
                  <span
                    @click="handleCopy(row.scope.remark)"
                  ><img src="@/assets/images/order/copy3.png" />复制</span
                  >
                </div>
                <div class="remarks-body">
                  {{ row.scope.remark }}
                </div>
              </div>
              <img
                v-if="row.scope.remark"
                slot="reference"
                style="cursor: pointer"
                src="@/assets/images/bill/remark.png"
              />
            </el-popover>
          </template>
          <template slot="createdOn" slot-scope="row">
            {{ row.scope.createdOn | dateFilete }}
          </template>
          <div slot="opt" slot-scope="row" class="optbtn">
            <div title="查看" class="btn" @click="check(row.scope)">
              <i class="el-icon-zoom-in"></i>
            </div>
            <div title="下载" class="btn" @click="download(row.scope)">
              <img src="@/assets/images/bill/download.png" alt="" />
            </div>
            <div
              v-if="row.scope.allowDel"
              title="删除"
              class="btn"
              @click="deleteFile(row.scope)"
            >
              <i class="el-icon-delete"></i>
            </div>
            <div
              v-if="rePushFms(row.scope)"
              title="重推fms"
              class="btn"
              @click="rePushFmsFile(row.scope)"
            >
              <i class="el-icon-top-right"></i>
            </div>
            <el-popover
              v-if="row.scope.allowEditOwnerBolInfo"
              v-model="popoverVisible"
              placement="bottom"
              width="366"
              trigger="click"
            >
              <div slot="reference" class="btn">
                <i class="el-icon-edit-outline"></i>
              </div>
              <div style="padding: 12px">
                <el-form style="margin: 0 auto" label-position="top">
                  <el-form-item label="卡车">
                    <el-input v-model="form.truckCompany"></el-input>
                  </el-form-item>
                  <el-form-item label="自提单号">
                    <el-input v-model="form.selfPickupNumber"></el-input>
                  </el-form-item>
                  <el-form-item label="提货时间">
                    <el-date-picker
                      v-model="form.deliveryTime"
                      type="date"
                      placeholder="选择日期"
                      style="width: 100%"
                      value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-form>
                <div style="display: flex; justify-content: center">
                  <div
                    style="
                      width: 68px;
                      height: 24px;
                      font-family: Microsoft YaHei, Microsoft YaHei;
                      font-weight: 400;
                      font-size: 14px;
                      color: #ffffff;
                      line-height: 24px;
                      text-align: center;
                      margin-left: 8px;
                      background: rgba(35, 149, 243, 1);
                      border-radius: 4px 4px 4px 4px;
                    "
                    @click="editOwner(row.scope)"
                  >
                    确认
                  </div>
                </div>
              </div>
            </el-popover>
          </div>
        </BaseTable> -->
      </div>
      <div class="footer">*暂时只支持图片和PDF查看</div>
    </div>
  </el-dialog>
</template>

<script>
// const BaseTable = () => import('@/components/table/BaseTable')
import {
  uploadMBLFile,
  deleteMBLFile,
  updateOwerBOLMBLFileData,
  pushFMSFile
} from '@/api/system'
import { downLoadMBLFile, getGroupList } from '@/api/bill'
import { mblFileConfig, getMBLSendWay } from '@/api/bill'
import pdfIcon from '@/assets/images/file/pdf.png'
import imageIcon from '@/assets/images/file/img.png'
import videoIcon from '@/assets/images/file/xlsx.png'
export default {
  components: {
    // BaseTable
  },
  filters: {
    dateFilete: function(date) {
      if (date) {
        return date.slice(0, date.length - 3)
      } else {
        return ''
      }
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {}
    },
    diaLogType: {
      type: Number,
      default: 0
    },
    fillType: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      type: '',
      tableData: {
        fileds: [
          {
            filed: 'fileName',
            label: '文件名',
            width: '',
            resizable: true,
            isCustom: true
          },
          {
            filed: 'typeName',
            label: '上传类型',
            width: '100',
            resizable: true,
            isCustom: true
          },
          {
            filed: 'mblSendWayName',
            label: '派送方式',
            width: '100',
            resizable: true
          },
          {
            filed: 'remark',
            label: '备注',
            width: '80',
            resizable: true,
            isCustom: true
          },
          {
            filed: 'createdOn',
            label: '上传时间',
            width: '150',
            isCustom: true,
            resizable: true
          },
          {
            filed: 'createdName',
            label: '上传人',
            width: '80',
            resizable: true
          },
          {
            filed: 'opt',
            label: '操作',
            width: '120',
            isCustom: true,
            resizable: true
          }
        ],
        columns: [],
        total: 0
      },
      loading: false,
      // options: [
      //   { label: 'AN', value: 1 },
      //   { label: 'DO', value: 2 },
      //   { label: '拆柜清单', value: 12 },
      //   { label: '其他', value: 99 }
      //   // { label: 'ISA', value: 3, children: [] },
      //   // { label: 'POD', value: 4, children: [] },
      // ],
      fileList: [],
      sendWayList: [],
      remark: '',
      form: {
        truckCompany: '',
        selfPickupNumber: '',
        deliveryTime: ''
      },
      popoverVisible: false
    }
  },
  computed: {
    fileOptions() {
      return this.fileList.map((item) => {
        const obj = {
          value: item.value,
          label: item.label
        }
        if (item.isMblSendWay && this.sendWayList.length > 0) {
          obj.children = []
          this.sendWayList.forEach((item) => {
            const sendWay = {
              value: item.id,
              label: item.code
                ? `${item.typeName}-${item.code}`
                : item.typeName
            }
            obj.children.push(sendWay)
          })
        }
        return obj
      })
    }
  },
  watch: {
    async dialogVisible(val) {
      if (val) {
        if (this.fillType) {
          this.type = this.fillType
        } else {
          this.type = ''
        }
        this.remark = ''
        this.getList()
        this.getConfig()
        this.getSendWay()
      }
    }
  },
  methods: {
    getIcon(fileName) {
      const suffix = fileName.slice(fileName.lastIndexOf('.') + 1, fileName.length)
      if (['jpg', 'jpeg', 'png'].includes(suffix.toLowerCase())) {
        return imageIcon
      } else if (['pdf'].includes(suffix.toLowerCase())) {
        return pdfIcon
      } else if (['xlsx'].includes(suffix.toLowerCase())) {
        return videoIcon
      } else {
        return ''
      }
    },
    beforeClose() {
      this.tableData.columns = []
      this.fileInfo = null
      this.$emit('close')
    },
    async getSendWay() {
      try {
        const res = await getMBLSendWay({
          mblId: this.rowData.id
        })
        if (res.success) {
          this.sendWayList = res.data
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    async getConfig() {
      try {
        const res = await mblFileConfig({
          status: this.rowData.status
        })
        // 过滤T01的 提单发票 和 更新发票选项
        this.fileList = res.data.filter(
          (item) => {
            if (this.rowData.clearanceMode === 2) {
              return true
            } else {
              return item.fileType !== 5 && item.fileType !== 18
            }
          },
        )
      } catch (error) {
        console.log(error)
      }
    },
    async getList() {
      try {
        const result = await getGroupList({ mblId: this.rowData.id })
        if (result.success) {
          this.tableData.columns = result.data.map((item) => {
        return {
          groupName: item.groupName,
          files: item.files?.map((obj) => {
            return {
              ...obj,
              icon: this.getIcon(obj.fileName)
            }
          })
        }
      })
        } else {
          this.$message.error(result.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    async httpRequest({ file }) {
      console.log(file.type)
      // const types = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']
      // const isImage = types.includes(file.type)
      // if (!isImage && this.type[0] !== 7) {
      //   this.$message.error('该类型只能上传图片和PDF文件')
      //   return false
      // }
      // const types2 = ['application/pdf']
      // const isXlsx = types2.includes(file.type)
      // if (!isXlsx && this.type[0] === 7) {
      //   this.$message.error('该类型只能上传pdf文件')
      //   return false
      // }
      const fileName = file.name
      if (fileName.length > 80) {
        this.$message.error('文件名字长度不能超过80')
        return
      }
      if (!this.type) {
        this.$message.error('请先选择上传类型')
        return
      }
      const selectFile = this.fileList.find((a) => a.value === this.type[0])
      if (selectFile.remarkRequired && !this.remark) {
        this.$message.error('请填写备注')
        return false
      }
      const types = selectFile.fileFilter
      const isImage = types.includes(file.type)
      if (!isImage && !this.attachmentType) {
        this.$message.error(
          `请上传符合格式的文件 ${selectFile.fileFilter.join(';')}`,
        )
        return false
      }
      // 正则判断全角字符
      const reg = /[\uff00-\uffff]/g
      if (
        Array.isArray(fileName.match(reg)) &&
        fileName.match(reg).length > 0
      ) {
        this.$message.error('上传失败，文件名不能存在特殊字符')
        return
      }
      const sameTypeFile = this.tableData.columns.filter((a) => {
        const fileConfig = this.fileList.find((a) => a.value === this.type[0])
        if (!fileConfig.isMblSendWay) {
          return +a.type === +this.type[0]
        } else {
          return +a.type === +this.type[0] && +a.mblSendWayId === +this.type[1]
        }
      })
      if (sameTypeFile.length > 0 && selectFile.confirmRequired) {
        this.$confirm('当前文件类型已存在， 是否继续上传', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          iconClass: 'warning',
          showClose: false,
          closeOnPressEscape: false,
          closeOnClickModal: false,
          center: true
        })
          .then(() => {
            this.uploadFile(file)
          })
          .catch(() => {})
      } else {
        this.uploadFile(file)
      }
    },
    async uploadFile(file) {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('mblId', this.rowData.id)
      formData.append('remark', this.remark)
      formData.append('uploadType', this.type[0])
      try {
        // const params = {
        //   source: this.type[0],
        //   id: this.rowData.id,
        //   remark: this.remark || ''
        // }
        if ([3, 4, 16, 20].indexOf(parseInt(this.type[0], 10)) > -1) {
          formData.append(
            'mblSendWayId',
            this.type[1] ? this.type[1] : undefined,
          )
          // params.mblSendWayId = this.type[1] ? this.type[1] : undefined
        }
        this.loading = true
        const result = await uploadMBLFile(formData)
        this.loading = false
        if (result.data.success) {
          parseInt(this.type[0], 10) === 7 && this.$emit('ok')
          this.$message.success('上传成功')
          setTimeout(() => {
            this.getList()
          }, 500)
        } else {
          this.$message.error(result.data.errorMessage)
        }
      } catch (error) {
        this.$message.error('上传失败')
      }
    },
    check(item) {
      const suffix = item.fileName.slice(
        item.fileName.lastIndexOf('.') + 1,
        item.fileName.length,
      )
      // const { fileGuid } = item
      if (
        suffix.toLowerCase() === 'jpg' ||
        suffix.toLowerCase() === 'jpeg' ||
        suffix.toLowerCase() === 'png'
      ) {
        this.$viewerApi({
          images: [item.filePath]
        })
      } else if (suffix.toLowerCase() === 'pdf') {
        window.open(item.filePath)
      } else {
        this.$message.error('暂时只支持图片和PDF查看')
      }
    },
    async download(v) {
      try {
        const res = await downLoadMBLFile({ guid: v.fileGuid })
        if (res) {
          const elink = document.createElement('a')
          elink.style.display = 'none'
          elink.href = res
          elink.type = 'download'
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        }
        console.log(res)
      } catch (error) {
        console.log(error)
      }
    },
    deleteFile(row) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        iconClass: 'warning',
        showClose: false,
        closeOnPressEscape: false,
        closeOnClickModal: false,
        center: true
      })
        .then(() => {
          deleteMBLFile({
            fileGuid: row.fileGuid
          }).then((res) => {
            if (res.success) {
              this.$message.success('删除成功')
              this.getList()
            } else {
              this.$message.error(res.errorMessage)
            }
          })
        })
        .catch(() => {})
    },
    handleCopy(v) {
      const url = v
      const oInput = document.createElement('input')
      oInput.value = url
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;

      document.execCommand('Copy') // 执行浏览器复制命令
      this.$message({
        message: '复制成功',
        type: 'success'
      })
      oInput.remove()
    },
    async editOwner(row) {
      try {
        const params = {
          id: row.id,
          ...this.form
        }
        const res = await updateOwerBOLMBLFileData(params)
        if (res.success) {
          this.$message.success('上传成功')
          this.popoverVisible = false
          this.getList()
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    rePushFms(row) {
      return !!row.tagsJson?.find((a) => a.value === 'PushFMS')
    },
    async rePushFmsFile(row) {
      try {
        const res = await pushFMSFile({
          mblFileId: row.id
        })
        if (res.success) {
          this.$message.success('操作成功')
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style scoped lang="less">
/deep/ .el-dialog__body {
  padding-bottom: 10px;
}
.view {
  position: relative;
  width: 100%;
  margin: 0 auto;
  .opt {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 32px;
    margin-bottom: 16px;
    z-index: 2;
    .upload {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 140px;
      height: 32px;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid rgb(18, 88, 188);
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: rgb(18, 88, 188);
      margin-left: 20px;
      box-sizing: border-box;
      cursor: pointer;
      img {
        margin-right: 4px;
      }
    }
    .label {
      display: inline-block;
      width: auto;
      margin-right: 5px;
    }
  }
  .data {
    position: relative;
    border-radius: 6px 6px 6px 6px;
    overflow: hidden;
    z-index: 1;
    &:deep(.fTable) {
      .fp-cell {
        border: 0;
      }
    }
    .tag {
      display: inline-block;
      padding: 0 4px;
      font-size: 12px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      color: rgb(18, 88, 188);
      line-height: 16px;
      & + .tag {
        margin-left: 4px;
      }
    }
  }
  &:deep(.el-select),
  &:deep(.el-input) {
    input {
      height: 34px;
      line-height: 34px;
    }
  }
  // &:deep(.el-textarea__inner) {
  //   resize: none;
  // }
  .footer {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    margin-top: 5px;
    padding-right: 16px;
    box-sizing: border-box;
    font-size: 12px;
    font-weight: 400;
    color: #cdcdcd;
  }
  .optbtn {
    display: flex;
    justify-content: space-around;
  }
  .btn {
    display: flex;
    align-items: center;
    font-size: 12px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: rgb(18, 88, 188);
    cursor: pointer;
    img {
      margin-right: 4px;
    }
    i {
      font-size: 18px;
      margin-right: 4px;
    }
  }
}
.ggt {
  width: auto;
  height: 24px;
  background: rgba(157, 103, 254, 0.1);
  border-radius: 4px 4px 4px 4px;
  padding: 4px 5px;
  box-sizing: border-box;
  font-size: 12px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  color: #9d67fe;
}
</style>

<style lang="less">
.el-popper {
  .view-detail {
    width: 100%;
    max-height: 240px;
    height: auto;
    overflow-y: scroll;
  }
  .eventItems {
    width: 100%;
    padding: 8px;
    background: #f8fbff;
    border-radius: 6px 6px 6px 6px;
    box-sizing: border-box;
  }
}
.remarks-box {
  width: 100%;
  height: 240px;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #eeeeee;
  box-sizing: border-box;
  overflow: hidden;
  .remarks-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 40px;
    background: #f7f7f7;
    border-bottom: 1px solid #eeeeee;
    box-sizing: border-box;
    padding: 0 20px;
    font-size: 12px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    & span:nth-child(2) {
      color: rgb(18, 88, 188);
      cursor: pointer;
    }
  }
  .remarks-body {
    width: 100%;
    height: calc(100% - 40px);
    padding: 15px 20px;
    box-sizing: border-box;
    font-size: 12px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    overflow-y: auto;
  }
}
.file-group-title {
  width: 100%;
  height: 40px;
  background: #f2f3f5;
  border-radius: 6px 6px 0px 0px;
  padding: 12px 24px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #262e47;
  box-sizing: border-box;
  border-bottom: 1px solid transparent;
}
.file-list {
  width: 100%;
  min-height: 50px;
  border: 1px solid #e5e5e5;
  border-top: 0;
  border-radius: 0px 0px 6px 6px;
  box-sizing: border-box;
}
.file-item {
  height: 40px;
  padding: 11px 20px;
  border-bottom: 1px solid #e5e5e5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  gap: 0 30px;
  &:last-child {
    border-bottom: none;
  }
  .file-name-box {
    display: flex;
    align-items: center;
    width: 40%;
    gap: 12px;
    .file-item-icon {
      width: 24px;
      height: 24px;
      img {
        width: 24px;
        height: 24px;
      }
    }
    .file-item-name {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 14px;
      color: #262e47;
    }
    .common-label-success {
      white-space: nowrap;
      background: #e6fbf2;
      color: #35ba83;
    }
  }

  .file-item-time {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    color: #999999;
  }
  .file-item-remark {
    width: 200px;
    height: 16px;
    font-size: 12px;
    color: #666666;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
